import request from '@/utils/request'
/* 
活动预约
 */
//查询是否有新的活动
export function seeVolunteerActivity(data) {
  return request({
    url: '/wx/release/toSee.do',
    method: 'post',
		data
  })
}


//查询活动列表
export function getVolunteerActivities(data) {
  return request({
    url: '/wx/release/getPltVolunteerActivity.do',
    method: 'post',
		data
  })
}

//查询活动时间信息
export function activityTime(data) {
  return request({
    url: '/wx/release/getActivityTimes.do',
    method: 'post',
		data
  })
}
//查询活动详情信息
export function getActivityInfo(data) {
  return request({
    url: '/wx/release/getActivityOne.do',
    method: 'post',
		data
  })
}

//志愿者活动报名
export function addActivityReserve(data) {
  return request({
    url: '/wx/release/addActivityReserve.do',
    method: 'post',
		data
  })
}

//志愿者活动报名(多日期)
export function addActivityReserveFw(data) {
  return request({
    url: '/wx/release/addActivityReserveFw.do',
    method: 'post',
		data
  })
}

//查询我的活动
export function getMyActivities(data) {
  return request({
    url: '/wx/release/getMyActivityReserve.do',
    method: 'post',
		data
  })
}
//取消我的活动
export function cancelMyActivity(data) {
  return request({
    url: '/wx/release/delectMyActivityReserve.do',
    method: 'post',
		data
  })
}


// WEBPACK FOOTER //
// ./src/api/activity.js